package pl.decks.chartjs.radar.options

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.radar.options.plugins.RadarPluginOptions

data class RadarOptions(
    val responsive: Boolean = true,
    val maintainAspectRatio: Boolean = true,
    val animation: RadarAnimationOptions? = null,
    val interaction: InteractionOptions? = null,
    val scale: RadarScaleOptions? = null,
    val plugins: RadarPluginOptions? = null,
    val layout: LayoutOptions? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.responsive = responsive.asDynamic()
        this.maintainAspectRatio = maintainAspectRatio.asDynamic()
        if (animation != null) this.animation = animation.toChartJs()
        if (interaction != null) this.interaction = interaction.toChartJs()
        if (scale != null) this.scales = jso { this.r = scale.toChartJs() }
        if (plugins != null) this.plugins = plugins.toChartJs()
        if (layout != null) this.layout = layout.toChartJs()
    }
}
